module.exports = __webpack_public_path__ + "img/box_mark.3f6daf3f.png";